import { Routes } from '@angular/router';
import { ValidaEmail } from './pages/login/valida-email/valida-email';
import { authGuardGuard } from './guards/auth-guard-guard';
import { authSessionGuard } from './guards/auth-session-guard';
import { Login } from './pages/login/login/login';
import { ConclusaoFicha } from './pages/curso/cadastro/form-aluno/conclusao-ficha/conclusao-ficha';
import { Termo } from './pages/curso/cadastro/form-aluno/conclusao-ficha/termo/termo';
import { GeraBoleto } from './pages/curso/cadastro/form-aluno/conclusao-ficha/gera-boleto/gera-boleto';
import { Info } from './pages/curso/cadastro/form-aluno/conclusao-ficha/info/info';
import { TermoNaoAceito } from './pages/curso/cadastro/form-aluno/conclusao-ficha/termo-nao-aceito/termo-nao-aceito';
import { SharedLayout } from './components/shared-layout/shared-layout';
import childrenAlunoDashboard from './childrenRoutes/childrenAlunodashboard';

export const routes: Routes = [
  {
    path: 'login',
    component: Login,
  },
  {
    path: 'valida-email',
    component: ValidaEmail
  },
  {
    //Area do aluno
    path: 'dashboard',
    component: SharedLayout,
    children: childrenAlunoDashboard,
    canActivate: [authGuardGuard]
  },
  {
    path: 'coordinator-dashboard',
    loadComponent: () => import('./pages/coordinator-dashboard/coordinator-dashboard').then(m => m.CoordinatorDashboard),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/personal-data',
    loadComponent: () => import('./pages/coordinator/personal-data/personal-data.component').then(m => m.CoordinatorPersonalDataComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/courses',
    loadComponent: () => import('./pages/coordinator/courses/courses.component').then(m => m.CoordinatorCoursesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/courses/enrollment',
    loadComponent: () => import('./pages/coordinator/courses/courses.component').then(m => m.CoordinatorCoursesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/courses/active',
    loadComponent: () => import('./pages/coordinator/courses/courses.component').then(m => m.CoordinatorCoursesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/courses/completed',
    loadComponent: () => import('./pages/coordinator/courses/courses.component').then(m => m.CoordinatorCoursesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/courses/enrollment-flow',
    loadComponent: () => import('./pages/coordinator/courses/courses.component').then(m => m.CoordinatorCoursesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/payments',
    loadComponent: () => import('./pages/coordinator/payments/payments.component').then(m => m.CoordinatorPaymentsComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/payments/blocked',
    loadComponent: () => import('./pages/coordinator/payments/payments.component').then(m => m.CoordinatorPaymentsComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/payments/overdue',
    loadComponent: () => import('./pages/coordinator/payments/payments.component').then(m => m.CoordinatorPaymentsComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/late-grades',
    loadComponent: () => import('./pages/coordinator/late-grades/late-grades.component').then(m => m.CoordinatorLateGradesComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/reports',
    loadComponent: () => import('./pages/coordinator/reports/reports.component').then(m => m.CoordinatorReportsComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/reports/aiu-recebido',
    loadComponent: () => import('./pages/coordinator/reports/aiu-recebido/aiu-recebido.component').then(m => m.AiuRecebidoComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'coordinator/reports/valor-liquido',
    loadComponent: () => import('./pages/coordinator/reports/valor-liquido/valor-liquido.component').then(m => m.ValorLiquidoComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'troca-senha',
    loadComponent: () => import('./pages/troca-senha/troca-senha/troca-senha').then(m => m.TrocaSenha)
    // component: TrocaSenha
  },
  {
    path: 'cadastro',
    // component: Cadastro
    loadComponent: () => import('./pages/login/cadastro/cadastro').then(m => m.Cadastro)
  },
  {
    path: 'cadastro-curso',
    loadComponent: () => import('./pages/curso/cadastro/form-aluno/form-aluno').then(m => m.FormAluno),
    canActivate: [authGuardGuard]
  },
  {
    path: 'curso-cadastrado-sucesso',
    component: ConclusaoFicha,
    children: [
      {
        path: 'continuo-termo',
        component: Termo,
        canActivate: [authGuardGuard]
      }, {
        path: 'boleto',
        component: GeraBoleto,
        canActivate: [authGuardGuard]
      }, {
        path: 'info',
        component: Info,
        canActivate: [authGuardGuard]
      },
      {
        path: 'termo-nao-aceito',
        component: TermoNaoAceito,
        canActivate: [authGuardGuard]
      }
    ],
  },
  // {
  //   path: 'edita-curso/:id',
  //   component: EditarAlunoComponent
  // },
  {
    path: 'termo-nao-aceito',
    component: TermoNaoAceito
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
